import React from 'react';

const SavvytronFooter = () => {
  return (
    <div className="mt-10 text-center text-sm text-gray-500">
      Built with ❤️ by{' '}
      <a
        href="https://savvytron.com"
        target="_blank"
        rel="noopener noreferrer"
        className="text-candy-primary hover:underline"
      >
        SavvyTron
      </a>
    </div>
  );
};

export default SavvytronFooter;
